
const VideoContent = ({videoUrl, videoWidth}) => {
    
    return (        
       <>
        {videoUrl && <div className="innerpage-2 communicados ck-content"><div className="video-container"><iframe className="video" width={`${videoWidth}%`} height="100%" src={videoUrl} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen=""></iframe></div></div>}
       </>
  );
};


export default VideoContent;